import { PageNotFoundError } from '@/utils/errors';
import { isNotFound } from '@tanstack/react-router';

export function isPageNotFoundError(error: unknown): boolean {
  return error instanceof PageNotFoundError || isNotFound(error) || isStatusNotFoundError(error);
}

function isStatusNotFoundError(error: unknown): boolean {
  return typeof error === 'object' && error != null && 'status' in error && error.status === 404;
}
